import {fetch} from "utils/dataAccess";

export async function getRetailersRanking(startDate, endDate) {
    const params = new URLSearchParams({ startDate, endDate });

    const response = await fetch(`/dashboard/retailers_ranking_data?${params}`);

    return response.json();
}
